
export const roundVector = (p) => ({
    x: Math.round(p.x),
    y: Math.round(p.y),
});
